/**
 * Appends REQUEST async action type
 */

export const PENDING = (actionType: string) => `${actionType}_PENDING`;

/**
 * Appends SUCCESS async action type
 */

export const FULFILLED = (actionType: string) => `${actionType}_FULFILLED`;

/**
 * Appends FAILURE async action type
 */

export const REJECTED = (actionType: string) => `${actionType}_REJECTED`;
